/** Similar to service mocks, but transformers are functions that receive a service response and can return
    it with changes. This helps to keep the application behavior closer to reality, while allowing us to contrive
    service data to support some test cases. */

import { cloneDeep } from 'lodash';
import {
  someYieldSomeCci,
  yieldDataMultipleSeasons1,
  yieldDataMultipleSeasons2,
  yieldDataMultipleSeasons3
} from './test-cases/advancedScripting';

// Active test cases - Delete as they become obsolete.
const testCases = {
  someYieldSomeCci,
  yieldDataMultipleSeasons1,
  yieldDataMultipleSeasons2,
  yieldDataMultipleSeasons3
};

/** Get a transformer that can be used to alter a service response in a way that supports a test case.
 *  @param testCaseId  Indicates test case for which transformation should be made.
 *  @param url (optional) Service request URL including the full querystring. Will be used to match to a transformer.
 *  @param body (optional) Service request body. Will be used to match to a transformer.
 *  @returns null if no matching transformer was found. Otherwise returns a transformer function that receives a
 *           service response body as an object (JSON-parsed) param, and returns an object containing the transformed
 *           body.
 */
export const getResponseTransformer = ({testCaseId, url, body}) => {
  const testCase = testCases[testCaseId];
  if (!testCase) {
    // Not using logError() below because this function is only called from test code.
    console.error(`${testCaseId} not found.`); // eslint-disable-line no-console
    return null;
  }

  // Find a transformer that applies to this request.
  const match = testCase.responseTransformers.find(transformer =>
    (!transformer.urlMatch || transformer.urlMatch.test(url))
    && (!transformer.bodyMatch || transformer.bodyMatch.test(body)) );

  // Wrap the transformer to pass a clone of the response data. Safer, and simplifies writing transformers.
  return match ? (response) => match.transformResponse(cloneDeep(response)) : null;
};
